import { axiosInstance } from "..";

const addEscalationStatus = async (id, data) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .post(
        `/internal/pm/updateProject/${id}`,data
      )
      .then((res) => {
        if (res.status === 200) {
          return resolve(res);
        }
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export default addEscalationStatus;


